import { SESSION_STORAGE_HOTEL_FILTER_CURRENT_REQ_KEY } from '../core/Const' ;

/**
 * membaca req key yang di pakai saat ini 
 */
export function getCurrentAvailibilityRequestKey(): string {
    let ret: any = sessionStorage.getItem(SESSION_STORAGE_HOTEL_FILTER_CURRENT_REQ_KEY);
    return ret;
}


// WEBPACK FOOTER //
// ./src/utils/hotel-inquery-utils.ts